// ═══════════════════════════════════════════════════════════
// OiaWidgetHost — mounts the page-wide OIA widget instances once, in the authenticated
// shell: the Support launcher (support-scope token, bare inbox) and the billing popup
// that OIAWidget.changePlan(slug) opens. See lib/oia-widget.ts.
// ═══════════════════════════════════════════════════════════
import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import { useAuthStore } from "@/stores/auth.store";
import { initOiaSharedWidgets } from "@/lib/oia-widget";

export function OiaWidgetHost() {
  const memberId = useAuthStore((s) => s.memberId);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!memberId) return;
    void initOiaSharedWidgets(memberId, () => {
      // Plan changed → drop the cached entitlement server-side and re-read it.
      void api
        .post("/api/admin/license/check", {})
        .finally(() => queryClient.invalidateQueries({ queryKey: queryKeys.license.status }));
    });
  }, [memberId, queryClient]);

  return null;
}
